(function () {
  "use strict";

  if (window.__headerSearchBootstrap) {
    window.__headerSearchBootstrap.init(document);
    return;
  }

  var CLOSE_DURATION = 220;
  var FOCUS_DELAY = 50;
  var SCROLL_CLOSE_THRESHOLD = 16;

  function createController(box) {
    var sectionRoot = box.closest(".shopify-section") || document;
    var header = sectionRoot.querySelector("#beauty-header") || document.getElementById("beauty-header");
    var input = box.querySelector(".search-bar input");
    var closeButton = box.querySelector(".new-search-close");
    var triggers = sectionRoot.querySelectorAll(".new-search-container");
    var controller = new AbortController();
    var signal = controller.signal;
    var state = "closed";
    var lastTrigger = null;
    var animationFrame = null;
    var focusTimer = null;
    var closeTimer = null;
    var transitionHandler = null;
    var openingScrollY = 0;
    var isScrollListening = false;
    var ownsHeaderInert = false;

    function setExpanded(expanded) {
      triggers.forEach(function (trigger) {
        trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
      });
    }

    function clearPendingOpen() {
      if (animationFrame !== null) {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = null;
      }
      if (focusTimer !== null) {
        window.clearTimeout(focusTimer);
        focusTimer = null;
      }
    }

    function clearPendingClose() {
      if (closeTimer !== null) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (transitionHandler) {
        box.removeEventListener("transitionend", transitionHandler);
        transitionHandler = null;
      }
    }

    function stopScrollListener() {
      if (!isScrollListening) return;
      window.removeEventListener("scroll", onScroll);
      isScrollListening = false;
    }

    function startScrollListener() {
      if (isScrollListening) return;
      openingScrollY = window.scrollY;
      window.addEventListener("scroll", onScroll, { passive: true });
      isScrollListening = true;
    }

    function setHeaderHidden(hidden) {
      if (!header) return;
      header.classList.toggle("is-search-hidden", hidden);
      if (hidden) {
        if (!header.hasAttribute("inert")) {
          header.setAttribute("inert", "");
          ownsHeaderInert = true;
        }
      } else if (ownsHeaderInert) {
        header.removeAttribute("inert");
        ownsHeaderInert = false;
      }
    }

    function finishClose() {
      clearPendingClose();
      if (state === "closed") box.hidden = true;
    }

    function closeSearch(options) {
      options = options || {};
      if (state === "closed" && !options.immediate) return;

      state = "closed";
      clearPendingOpen();
      clearPendingClose();
      stopScrollListener();
      box.classList.remove("is-open");
      setHeaderHidden(false);
      setExpanded(false);

      if (options.restoreFocus !== false && lastTrigger && document.contains(lastTrigger)) {
        lastTrigger.focus({ preventScroll: true });
      } else if (document.activeElement instanceof HTMLElement && box.contains(document.activeElement)) {
        document.activeElement.blur();
      }

      box.setAttribute("aria-hidden", "true");
      box.setAttribute("inert", "");

      if (options.immediate || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        finishClose();
      } else {
        transitionHandler = function (event) {
          if (event.target === box && event.propertyName === "opacity") finishClose();
        };
        box.addEventListener("transitionend", transitionHandler);
        closeTimer = window.setTimeout(finishClose, CLOSE_DURATION);
      }
    }

    function onScroll() {
      if (state === "open" && Math.abs(window.scrollY - openingScrollY) >= SCROLL_CLOSE_THRESHOLD) {
        closeSearch({ restoreFocus: false });
      }
    }

    function closeMobileMenu() {
      if (!header) return;
      var mobileHeader = header.querySelector(".bh-mo.is-open");
      var menuToggle = mobileHeader ? mobileHeader.querySelector(".bh-mo__toggle") : null;
      if (menuToggle) menuToggle.click();
    }

    function openSearch(trigger) {
      if (state === "open") return;

      clearPendingClose();
      closeMobileMenu();
      state = "open";
      lastTrigger = trigger || null;
      box.hidden = false;
      box.removeAttribute("inert");
      box.setAttribute("aria-hidden", "false");
      setHeaderHidden(true);
      setExpanded(true);
      startScrollListener();

      animationFrame = window.requestAnimationFrame(function () {
        animationFrame = null;
        if (state === "open") box.classList.add("is-open");
      });

      focusTimer = window.setTimeout(function () {
        focusTimer = null;
        if (state === "open" && input) input.focus({ preventScroll: true });
      }, FOCUS_DELAY);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener(
        "click",
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (state === "open") {
            closeSearch();
          } else {
            openSearch(trigger);
          }
        },
        { signal: signal },
      );
    });

    if (closeButton) {
      closeButton.addEventListener(
        "click",
        function () {
          closeSearch();
        },
        { signal: signal },
      );
    }

    document.addEventListener(
      "click",
      function (event) {
        if (state !== "open" || !(event.target instanceof Element)) return;
        if (!event.target.closest("#new-search-container-box") && !event.target.closest(".new-search-container")) {
          closeSearch({ restoreFocus: false });
        }
      },
      { signal: signal },
    );

    document.addEventListener(
      "keydown",
      function (event) {
        if (event.key === "Escape" && state === "open") closeSearch();
      },
      { signal: signal },
    );

    return {
      destroy: function () {
        closeSearch({ immediate: true, restoreFocus: false });
        controller.abort();
        stopScrollListener();
        delete box.__headerSearchController;
      },
    };
  }

  function init(scope) {
    var boxes = [];
    if (scope instanceof Element && scope.matches("#new-search-container-box")) boxes.push(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll("#new-search-container-box").forEach(function (box) {
        boxes.push(box);
      });
    }

    boxes.forEach(function (box) {
      if (!box.__headerSearchController) {
        box.setAttribute("inert", "");
        box.__headerSearchController = createController(box);
      }
    });
  }

  function destroy(scope) {
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll("#new-search-container-box").forEach(function (box) {
      if (box.__headerSearchController) box.__headerSearchController.destroy();
    });
  }

  window.__headerSearchBootstrap = { init: init, destroy: destroy };

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    destroy(event.target);
  });

  init(document);
})();
